import React from "react";
import useModal from "../../hooks/useModal";
import ModalDialog from "./modalDialog";

const ModalManager: React.FC = () => {
	const { modals, hide: hideModal } = useModal();

	// Handle the modal close and pass the result
	const handleClose = (event?: {}) => {
		hideModal(event);
	};

	const onCloseHandler = (event: {}, reason: 'backdropClick' | 'escapeKeyDown') => {
		if (reason === 'backdropClick') {
			return;
		}

		handleClose(event);
	};

	return (
		<div id="modalManager">
			{modals.map((modal, index) => (
				<ModalDialog
					key={index}
					open={modal.open}
					width={modal.width}
					onClose={onCloseHandler}
					titleIcon={modal.titleIcon}
					title={modal.title}
					body={modal.content}
					showTitle={modal.showTitle}
				/>
			))}
		</div>
	);
};

export default ModalManager;
